angular.module("UI8.components").component("passPricing", {
  template:
    `
    <div class="pass">` +
    // <div class="pass__tabs" ng-class="{'is-yearly': !$ctrl.monthly}">
    //   <button
    //     ng-class="{active: $ctrl.monthly}"
    //     ng-click="$ctrl.monthly = true"
    //   >Monthly</button>
    //   <button
    //     ng-class="{active: !$ctrl.monthly}"
    //     ng-click="$ctrl.monthly = false"
    //   >Yearly<span>Save ~70%</span></button>
    // </div>

    `<div class="pass__container">

        <div class="pass__list" ng-class="{'has-message': $ctrl.userHasLifetime || $ctrl.userValidOldPass}">
          <div
            class="pass__item"
            ng-class="{'pass__item--featured': item.featured}"
            ng-repeat="item in ($ctrl.monthly ? $ctrl.monthlyList : $ctrl.yearlyList)"
          >
            <div class="pass__type">{{ item.name || item.pass.name }}<span class="pass__popular" ng-if="item.featured">Most popular</span></div>
            <div class="pass__price">
              <div class="pass__price-value">{{ (item.price || item.pass.price) | ui8Currency }}</div>
              <div class="pass__price-meta">
                <div class="pass__price-old">{{ item.original || $ctrl.originalPrice(item.pass) }}</div>
                <div class="pass__price-label pass__price-label--stacked">{{ $ctrl.intervalLabel(item.pass) }}</div>
              </div>
            </div>

            <div class="pass__btn btn active"
              ng-if="$ctrl.currentPass(item.pass._id)"
            >Current plan</div>

            <div class="pass__btn btn disabled"
              ng-if="!$ctrl.currentPass(item.pass._id) && !$ctrl.canBuyPass(item.pass)"
            >Get {{ item.name || item.pass.name }}</div>

            <button class="pass__btn btn"
              ng-if="$ctrl.canBuyPass(item.pass)"
              ng-click="$ctrl.pickPass(item)"
            >Get {{ item.name || item.pass.name }}</button>

            <ul class="pass__details">
              <li
                ng-repeat="detail in item.details"
                ng-class="{'not-include': detail.excluded, 'is-bot': detail.bot}"
              >
                <span class="pixbot pass__bot" ng-if="detail.bot" aria-hidden="true">
                  <svg viewBox="0 0 9 8" shape-rendering="crispEdges" focusable="false">
                    <g class="pixbot__body">
                      <rect class="pixbot__tip pixbot__tip--blue" x="1" y="0" width="1" height="1"></rect>
                      <rect class="pixbot__tip pixbot__tip--pink" x="7" y="0" width="1" height="1"></rect>
                      <path class="pixbot__stem" d="M2 1h1v1H2zM6 1h1v1H6z"></path>
                      <path class="pixbot__head" d="M1 2h7v1h1v4h-1v1h-7v-1h-1v-4h1z"></path>
                      <g class="pixbot__eyes"><rect x="2" y="4" width="1" height="2"></rect><rect x="6" y="4" width="1" height="2"></rect></g>
                    </g>
                  </svg>
                </span>
                <span ng-bind-html="$ctrl.parseDetail(detail.text)"></span>
              </li>
            </ul>
          </div>
        </div>

        <ul class="pass__old" ng-if="$ctrl.userIsAdmin">
          <li ng-repeat="pass in $ctrl.oldPasses">
            <button class="btn btn--green" ng-click="$ctrl.addOldToCart(pass._id)">{{ pass.name }} / {{ pass.price | ui8Currency }}</button>
          </li>
          <li ng-repeat="item in $ctrl.discountedPasses">
            <button class="btn btn--green" ng-click="$ctrl.addDiscountedToCart(item.pass._id)">{{ item.label }} / {{ item.price | ui8Currency }}</button>
          </li>
        </ul>

        <div class="pass__message" ng-if="$ctrl.userHasLifetime">
          <div class="pass__message-title">
            <svg width="24" height="24" fill="none"><path stroke="#fff" stroke-linecap="square" stroke-width="2" d="m12 12 3.222 3.182a4.597 4.597 0 0 0 6.444 0 4.46 4.46 0 0 0 0-6.364 4.597 4.597 0 0 0-6.444 0zm0 0L8.778 8.818a4.597 4.597 0 0 0-6.443 0 4.46 4.46 0 0 0 0 6.364 4.597 4.597 0 0 0 6.443 0z"/></svg>
            Lifetime Plan
          </div>
          <div class="pass__message-content">
            <p>You’re on our Lifetime Plan. Thanks for your support. You’ll continue to have access to all current features, new tools, and upcoming features.</p>
          </div>
        </div>

        <div class="pass__message" ng-if="$ctrl.userValidOldPass">
          <div class="pass__message-title">You’re on an older plan</div>
          <div class="pass__message-content">
            <p>You’re currently on a plan that is no longer available. You can choose a new plan once your current plan is canceled and expires. In the meantime, you’ll still have access to all new tools and upcoming AI features.</p>
            <p><a href="/account/purchases">Manage plan</a></p>
          </div>
        </div>
      </div>
    </div>
  `,

  controller: function (CartService, PromoService, $sce) {
    var ctrl = this;

    ctrl.$onInit = function () {
      ctrl.userIsAdmin = window.UI8.userIsAdmin;
      ctrl.userHasLifetime = window.UI8.userHasLifetime;
      ctrl.userValidOldPass = window.UI8.userValidOldPass;
      ctrl.monthly = false;

      var find = (slug) => ctrl.subscriptions.find((s) => s.slug === slug);

      var oldPassSlugs = [
        "all-access-pass-starter",
        "all-access-pass-basic",
        "all-access-pass-pro",
        "all-access-pass-elite",
      ];

      ctrl.oldPasses = ctrl.subscriptions.filter((s) =>
        oldPassSlugs.includes(s.slug)
      );

      var discountMap = [
        {
          slug: "all-access-pass-basic",
          label: "All-Access Pass Basic (Discount)",
          price: 11200,
        },
        {
          slug: "all-access-pass-pro",
          label: "All-Access Pass Pro (Discount)",
          price: 16600,
        },
        {
          slug: "all-access-pass-elite",
          label: "All-Access Pass Elite (Discount)",
          price: 22000,
        },
      ];

      ctrl.discountedPasses = discountMap.reduce(function (acc, item) {
        var pass = ctrl.subscriptions.find(function (s) {
          return s.slug === item.slug;
        });
        if (pass)
          acc.push({ pass: pass, label: item.label, price: item.price });
        return acc;
      }, []);

      var proMonthly = find("pass-pro-monthly");
      var proPlusMonthly = find("pass-pro-plus-monthly");
      // Pro yearly ($179/yr) is parked, not deleted — swap pro3Month back to
      // find("pass-pro-yearly") to restore it.
      var pro3Month = find("pass-pro-3month");
      var proPlusYearly = find("pass-pro-plus-yearly");
      var lifetime = ctrl.subscriptions.find(function (s) {
        return s.subscription_lifetime;
      });

      // UI8 MCP calls a day by plan (helpers/pass-tier.js), shown once the
      // MCP's public links are on (MCP_LINKS), with its pixel bot for a bullet
      function mcpCalls(count) {
        return window.UI8.mcpLinks
          ? [{ text: count + " [MCP calls](/mcp) per day", bot: true }]
          : [];
      }

      var proDetails = [
        { text: "downloads per day", countKey: "daily_download_allowance" },
        // AI credits are parked, not dropped: restore this row when credits
        // come back, and remove the Clap Studio line.
        // { text: "AI credits/per month", counter: 30 },
      ].concat(mcpCalls("500"), [
        { text: "Access to all products" },
        { text: "Full access to [Clap Studio](https://clap.io/)" },
        { text: "Access to daily new releases" },
      ]);

      var proPlusDetails = [
        { text: "downloads per day", countKey: "daily_download_allowance" },
        // AI credits are parked, not dropped: restore this row when credits
        // come back, and remove the Clap Studio line.
        // { text: "AI credits/per month", counter: 50 },
      ].concat(mcpCalls("1,000"), [
        { text: "Access to all products" },
        { text: "Full access to [Clap Studio](https://clap.io/)" },
        { text: "Access to daily new releases" },
      ]);

      var lifetimeDetails = [
        { text: "downloads per day", countKey: "daily_download_allowance" },
        // AI credits are parked, not dropped: restore this row when credits
        // come back, and remove the Clap Studio line.
        // { text: "AI credits/per month", counter: 50 },
      ].concat(mcpCalls("2,000"), [
        { text: "Access to all products" },
        { text: "Full access to [Clap Studio](https://clap.io/)" },
        { text: "Access to daily new releases" },
      ]);

      function buildItem(pass, detailDefs) {
        if (!pass) return null;
        return {
          pass: pass,
          details: detailDefs.map(function (d) {
            if (d.countKey) {
              return {
                text: (pass[d.countKey] || "") + " " + d.text,
                excluded: d.excluded,
              };
            }
            if (d.counter) {
              return {
                text: d.counter + " " + d.text,
                excluded: d.excluded,
              };
            }
            return d;
          }),
        };
      }

      ctrl.monthlyList = [
        buildItem(proMonthly, proDetails),
        buildItem(proPlusMonthly, proPlusDetails),
        buildItem(lifetime, lifetimeDetails),
      ].filter(Boolean);

      ctrl.yearlyList = [
        buildItem(pro3Month, proDetails),
        buildItem(proPlusYearly, proPlusDetails),
        buildItem(lifetime, lifetimeDetails),
      ].filter(Boolean);

      // Pro+ is the highlighted "Most popular" card in both lists
      ctrl.monthlyList.concat(ctrl.yearlyList).forEach(function (item) {
        if (/pass-pro-plus/.test(item.pass.slug)) item.featured = true;
      });

      // Seasonal sale: the Pro and Pro+ cards sell the Basic (3 months) and
      // Elite (1 year) passes at the aap40 price, the same pair the admin
      // discount buttons use. The code is applied on click; Lifetime clears
      // it so the 40% never leaks onto that card.
      if (window.UI8.currentSale) {
        var saleBasic = find("all-access-pass-basic");
        var saleElite = find("all-access-pass-elite");
        if (saleBasic && saleElite) {
          var basicItem = buildItem(saleBasic, proDetails);
          var eliteItem = buildItem(saleElite, proPlusDetails);
          basicItem.name = "Pro";
          basicItem.sale = true;
          basicItem.price = 11200;
          basicItem.original = "$" + saleBasic.price / 100;
          eliteItem.name = "Pro+";
          eliteItem.sale = true;
          eliteItem.price = 22000;
          eliteItem.original = "$" + saleElite.price / 100;
          eliteItem.featured = true;
          ctrl.yearlyList = [basicItem, eliteItem, buildItem(lifetime, lifetimeDetails)].filter(Boolean);
        }
      }
    };

    ctrl.pickPass = function (item) {
      if (item.sale) return ctrl.addDiscountedToCart(item.pass._id);
      if (window.UI8.currentSale) {
        return PromoService.disablePromo().then(function () {
          ctrl.addToCart(item.pass._id);
        });
      }
      return ctrl.addToCart(item.pass._id);
    };

    // Sale framing: every card shows a struck-through "original" computed as
    // price / 0.7, so the advertised 30% stays exact whatever the product
    // docs are priced at.
    ctrl.originalPrice = function (pass) {
      return "$" + Math.round(pass.price / 100 / 0.7);
    };

    ctrl.intervalLabel = function (pass) {
      if (pass.subscription_lifetime) return "one-time";
      if (pass.subscription_months === 1) return "/month";
      if (pass.subscription_months === 3) return "/3 months";
      return "/year";
    };

    ctrl.parseDetail = function (text) {
      function esc(s) {
        return String(s)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;");
      }
      var html = esc(text).replace(/\[([^\]]+)\]\(([^)]+)\)/g, function (
        _,
        label,
        url
      ) {
        // only web or site links; anything else stays plain text
        if (!/^(https?:\/\/|\/(?!\/))/i.test(url)) return label;
        var external = url.indexOf("http") === 0;
        return (
          '<a href="' +
          esc(url) +
          '"' +
          (external ? ' target="_blank"' : "") +
          ">" +
          label +
          "</a>"
        );
      });
      return $sce.trustAsHtml(html);
    };

    ctrl.currentPass = function (passId) {
      return (
        window.UI8.userActivePass && window.UI8.userActivePassId === passId
      );
    };

    ctrl.lowerPassLevel = function (pass) {
      // No active pass — never block (no pass_expires, or pass expired)
      if (!window.UI8.userActivePass) return false;

      var userLevel = window.UI8.passLevel;
      var activePass = ctrl.subscriptions.find(function (s) {
        return s._id === window.UI8.userActivePassId;
      });
      // Fall back to active pass level if not set (e.g. recent purchase)
      if (userLevel == null || userLevel === false) {
        userLevel = activePass ? activePass.subscription_level : null;
      }
      if (userLevel == null || userLevel === false) return false;
      if (pass.subscription_level == null) return false;
      // Block cross-tier downgrade
      if (userLevel > pass.subscription_level) return true;
      // Block same-tier yearly → monthly downgrade
      if (
        userLevel === pass.subscription_level &&
        pass.subscription_months === 1
      ) {
        if (activePass && activePass.subscription_months > 1) return true;
      }
      return false;
    };

    ctrl.canBuyPass = function (pass) {
      return (
        !ctrl.currentPass(pass._id) &&
        !ctrl.userHasLifetime &&
        !ctrl.userValidOldPass &&
        !ctrl.lowerPassLevel(pass)
      );
    };

    ctrl.addOldToCart = function (productId) {
      PromoService.disablePromo().then(function () {
        ctrl.addToCart(productId);
      });
    };

    ctrl.addDiscountedToCart = function (productId) {
      PromoService.applyPromo("aap40").then(function (promo) {
        if (promo) {
          window.UI8.promo = promo;
          document.body.dispatchEvent(new Event("promo-updated"));
        }
        ctrl.addToCart(productId);
      });
    };

    ctrl.addToCart = function (productId) {
      var pass = ctrl.subscriptions.find(function (s) {
        return s._id === productId;
      });

      if (!ctrl.userIsAdmin) {
        if (!pass || !ctrl.canBuyPass(pass)) return;
      }

      CartService.addPassToCart(productId).then(function () {
        setTimeout(function () {
          window.scrollLock.disablePageScroll();

          var groupCart = $(".header__cell--cart"),
            groupNext = groupCart.find(".payup__sidebar .payup__btn"),
            groupLayout = groupCart.find(".payup__layout"),
            groupBack = groupCart.find(".payup__back");

          groupNext.on("click", function () {
            groupLayout.addClass("step-checkout");
          });
          groupBack.on("click", function () {
            groupLayout.removeClass("step-checkout");
          });
        }, 10);
      });

      if (ctrl.closeModal) $("body").removeClass("pass-pricing-modal");
    };
  },

  bindings: {
    subscriptions: "<",
    lifetime: "<",
    closeModal: "<?",
  },
});
